import axios from "axios";
import httpTools from "./httpTools";
import Q from "q";

const translationsLoader = (() => {
    //comments
    let translationUrl = httpTools.getTranslationUrl();
    return {
        get: locale => {
            let defer = Q.defer();
            axios
                .get(`${translationUrl}/${locale}.json`)
                .then(res => {
                    defer.resolve(res.data);
                })
                .catch(error => {
                    console.trace(error);
                    defer.reject(error);
                });
            return defer.promise;
        }
    };
})();

export default translationsLoader;



// WEBPACK FOOTER //
// ./src/services/http/translationsLoader.js